import { ResourcesManager, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import * as SPE from '@verybigthings/shader-particle-engine';
import { Color, Vector3 } from 'three';
export class SprayModule extends ViewerModule {
    constructor() {
        super();
        this.particleGroups = [];
        this.particleEmitters = [];
        this.inited = false;
        this.uiObject.raycast = () => {
        };
        this.uiObject['raycastOld'] = () => {
        };
        console.log('SprayModule constructor >>>>>>>>');
        Viewer.on('goToZSpace', () => {
            this.setZSpace(true);
        });
        Viewer.on('goFromZSpace', () => {
            this.setZSpace(false);
        });
    }
    init() {
        if (this.inited)
            return;
        this.inited = true;
        const particleGroup = new SPE.Group({
            texture: {
                value: ResourcesManager.getTexture(`particle_fire`),
            },
            fog: false,
            colorize: true,
            blending: 1,
            transparent: true
        });
        const particleEmitter = new SPE.Emitter(this.getEmitterOptions());
        particleGroup.addEmitter(particleEmitter);
        this.addObject(particleGroup.mesh);
        particleGroup.mesh.raycast = () => {
        };
        particleGroup.mesh['raycastOld'] = () => {
        };
        this.particleGroups.push(particleGroup);
        this.particleEmitters.push(particleEmitter);
        Viewer.on('update', () => {
            this.particleGroups.forEach(el => el.tick(1 / 30));
        });
    }
    setZSpace(value) {
        this.particleEmitters.forEach(emmiter => {
            if (value)
                emmiter.size.value = [0.015 / 5, 0.015 / 5, 0.015 / 5, 0.015 / 5];
            else
                emmiter.size.value = [0.015, 0.015, 0.015, 0.015];
        });
    }
    getEmitterOptions() {
        return {
            particleCount: 3000,
            maxAge: {
                value: 0.4,
                spread: 0
            },
            position: {
                value: new Vector3(0, 0, 0),
                spread: new Vector3(0, 0, 0),
                spreadClamp: new Vector3(0, 0, 0),
                distribution: SPE.distributions.Sphere,
                randomise: false
            },
            velocity: {
                value: new Vector3(0, 4, 0),
                spread: new Vector3(3, 0.5, 3),
                distribution: SPE.distributions.BOX,
                randomise: false
            },
            acceleration: {
                value: new Vector3(0, 0, 0),
                spread: new Vector3(0, 0, 0),
                // distribution: SPE.distributions.BOX,
                randomise: false
            },
            size: {
                value: 0.015 / (Viewer.controls.zController ? 5 : 1),
                spread: 0
            },
            color: {
                value: [new Color(0.6, 0.6, 1)]
            },
            opacity: {
                value: [1, 0.6]
            }
        };
    }
}
